import { FormEvent, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import { ICreateLiveClassFormValues } from 'types/liveClass';
import CircularProgress from '@mui/material/CircularProgress';
import EditLiveClassForm from './components/EditLiveClassForm';
import { useLiveClassQuery, useUpdateLiveClassMutation } from 'hooks/liveClasses';

const EditLiveClass = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [editedLiveClassData, setEditedLiveClassData] = useState<ICreateLiveClassFormValues | null>(
    null,
  );

  const { data, isLoading, isFetching, refetch, error } = useLiveClassQuery(id);
  const {
    mutateAsync: updateLiveClass,
    isLoading: isUpdating,
    error: errorOnUpdate,
  } = useUpdateLiveClassMutation(id);
  const loading = isLoading || isFetching;

  useEffect(() => {
    if (!loading && data) {
      const { basicSessionId, link, instructorName, scheduledDateTime, title, description } = data.data;

      setEditedLiveClassData({
        basicSessionId: {
          title: basicSessionId.title,
          status: basicSessionId.status,
          availability: basicSessionId.availability,
        },
        title,
        description,
        link,
        instructorName,
        scheduledDateTime,
      });
    }

    if (!isUpdating && errorOnUpdate) {
      alert('Error updating live class');
    }
  }, [data, errorOnUpdate, isUpdating, loading]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();

      if (!editedLiveClassData) return;
      const response = await updateLiveClass(editedLiveClassData);

      if (response.data) {
        alert('Live class updated successfully');
        history.push('/dashboard/list-live-classes');
      }
    } catch (error) {
      toast.error('Error updating live class');
    }
  };

  if (loading)
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={30} />
      </div>
    );

  if (error || !editedLiveClassData)
    return (
      <div>
        <p>Error fetching session data</p>
        <button
          type="button"
          onClick={() => refetch()}
          className="mt-4 btn btn-primary btn-block w-100 d-flex align-items-center justify-content-center"
        >
          Refetch
        </button>
      </div>
    );

  return (
    <div className="w-100">
      <h3>Edit Live Class</h3>

      <EditLiveClassForm
        isUpdating={isUpdating}
        handleSubmit={handleSubmit}
        editedLiveClassData={editedLiveClassData}
        setEditedLiveClassData={setEditedLiveClassData}
      />
    </div>
  );
};

export default EditLiveClass;
